import * as types from "./mutationTypes";

export default {
  [types.SET_SEGMENTS](state, segments) {
    state.segments = segments;
  },
  [types.CLEAR_SEGMENTS](state) {
    state.segments = null;
  },
  [types.SET_SEGMENT](state, segment) {
    state.segment = segment;
  },
  [types.CLEAR_SEGMENT](state) {
    state.segment = null;
  },
  [types.SET_NAME](state, name) {
    state.segment.name = name;
  },
  [types.SET_SURVEYS](state, surveys) {
    state.segment.rules.static.surveys = surveys;
  },
  [types.SET_DISTRIBUTIONS](state, distributions) {
    state.segment.rules.static.distributions = distributions;
  },
  [types.SET_SENDING_DATE](state, { starts_at, ends_at }) {
    state.segment.rules.static.sending_date.starts_at = starts_at;
    state.segment.rules.static.sending_date.ends_at = ends_at;
  },
  [types.SET_ANSWER_DATE](state, { starts_at, ends_at }) {
    state.segment.rules.static.answer_date.starts_at = starts_at;
    state.segment.rules.static.answer_date.ends_at = ends_at;
  },
  [types.SET_SENDING_CHANNEL](state, channel) {
    state.segment.rules.static.sending_channel = channel;
  },
  [types.SET_ANSWER_CHANNEL](state, channel) {
    state.segment.rules.static.answer_channel = channel;
  },
  [types.SET_ANSWER_STATUS](state, status) {
    state.segment.rules.static.answer_status = status;
  },
  [types.SET_SEND_STATUS](state, status) {
    state.segment.rules.static.send_status = status;
  },
  [types.SET_IDENTIFICATION](state, identification) {
    state.segment.rules.static.identification = identification;
  },
  [types.SET_HEALTH_SCORE](state, score) {
    state.segment.rules.static.health_score = score;
  },
  [types.SET_CATEGORIES](state, categories) {
    state.segment.rules.static.categories = categories;
  },
  [types.SET_METADATA](state, metadata) {
    state.segment.rules.metadata = metadata;
  },
  [types.ADD_SEGMENT](state, segment) {
    state.segments.unshift(segment);
  },
  [types.REMOVE_SEGMENT](state, uuid) {
    state.segments = state.segments?.filter((segment) => segment.uuid !== uuid);
  },
  [types.SET_SURVEY_OPTIONS](state, surveys) {
    state.surveyOptions = surveys;
  },
  [types.CLEAR_SURVEY_OPTIONS](state) {
    state.surveyOptions = null;
  },
  [types.SET_DISTRIBUTION_OPTIONS](state, distributions) {
    state.distributionOptions = distributions;
  },
  [types.CLEAR_DISTRIBUTION_OPTIONS](state) {
    state.distributionOptions = null;
  },
  [types.SET_METADATA_OPTIONS](state, metadata) {
    state.metadataOptions = metadata;
  },
  [types.CLEAR_METADATA_OPTIONS](state) {
    state.metadataOptions = null;
  },
  [types.SET_CATEGORY_OPTIONS](state, category) {
    state.categoryOptions = category;
  },
  [types.CLEAR_CATEGORY_OPTIONS](state) {
    state.categoryOptions = null;
  },
  [types.SET_STATIC_SEGMENT](state, staticSegment) {
    state.segment.rules.static = staticSegment;
  }
};
